import moment from "moment";
import { formatDate } from "react-lib/utils/dateUtils";
import CompanyLogoForm from "react-lib/apps/HISV3/common/CompanyLogoForm";
import CONFIG from "config/config";

const FORM_NAME = "FormAnesDoctorFeeList";

const FormAnesDoctorFeeList = async (props: any) => {
  const companyLogoForm = await CompanyLogoForm({
    font: "THSarabunNew",
    height: 50.5,
    form: FORM_NAME,
  });
  const { font, images } = companyLogoForm;

  return {
    defaultStyle: {
      font: font,
      lineHeight: 1,
      fontSize: 12,
    },
    pageMargins: [15, 125, 0, 50],
    pageSize: "A4",
    pageOrientation: "landscape",
    styles: {
      title: {
        bold: true,
        fontSize: 20,
        alignment: "center",
      },
      header: {
        fontSize: 18,
        alignment: "center",
      },
      tableHeader: {
        bold: true,
        fontSize: 14,
        alignment: "center",
      },
      tableDetail: {
        fontSize: 14,
      },
      addressRightStyle: {
        fontSize: 12,
        alignment: "right",
      },
      addressLeftStyle: {
        fontSize: 12,
        alignment: "left",
      },
    },
    header: {
      margin: [40, 20, 20, 20],
      stack: [
        {
          columns: [
            !CONFIG.HIDE_COMPANY_LOGO_PRINT ? {
              width: "50%",
              stack: [{ image: "logo", width: 150 }],
            } : null,
            !CONFIG.HIDE_COMPANY_LOGO_PRINT ? {
              width: "50%",
              stack: [
                {
                  text: "โรงพยาบาลคณะทันตแพทยศาสตร์ จุฬาลงกรณ์มหาวิทยาลัย",
                  style: "addressRightStyle",
                },
                {
                  text: [
                    {
                      text: "ที่อยู่ : ",
                      style: "addressRightStyle",
                      bold: true,
                    },
                    {
                      text: "34  ถนนอังรีดูนังต์  แขวงวังใหม่  เขตปทุมวัน",
                      style: "addressRightStyle",
                    },
                  ],
                },
                {
                  text: "กรุงเทพมหานคร  10330  โทร 0 2218 8635",
                  style: "addressRightStyle",
                },
              ],
            } : null,
          ],
        },
        {
          text: "รายงานค่าธรรมเนียมวิสัญญีแพทย์",
          style: "title",
        },
        {
          text: `วันที่ผ่าตัด ${props?.start_date} - ${props?.end_date}`,
          style: "header",
        },
      ],
    },
    content: [
      {
        margin: [20, 0, 10, 10],
        table: {
          widths: ["7%", "15%", "7%", "13%", "6%", "23%", "7%", "8%", "7%", "7%"],
          body: [
            [
              { text: "วันที่ผ่าตัด", style: "tableHeader" },
              { text: "วิสัญญีแพทย์", style: "tableHeader" },
              { text: "HN", style: "tableHeader" },
              { text: "ชื่อ - สกุล", style: "tableHeader" },
              { text: "Service Code", style: "tableHeader" },
              { text: "Product Name", style: "tableHeader" },
              { text: "จำนวนที่สั่ง", style: "tableHeader" },
              { text: "ราคาต่อหน่วย", style: "tableHeader" },
              { text: "ราคารวม", style: "tableHeader" },
              { text: "ค่าตอบแทน", style: "tableHeader" },
            ],
            ...(props?.data || []).map((item: any, index: number) => [
              {
                text: item.performDT,
                style: "tableDetail",
                alignment: "center",
              },
              { text: item.received_employee_display, style: "tableDetail" },
              { text: item.hn, style: "tableDetail", alignment: "center" },
              { text: item.patient_name, style: "tableDetail" },
              {
                text: item.service_code,
                style: "tableDetail",
                alignment: "center",
              },
              { text: item.doctor_fee_rule_display, style: "tableDetail" },
              { text: item.quantity, style: "tableDetail", alignment: "right" },
              {
                text: item.price_unit,
                style: "tableDetail",
                alignment: "right",
              },
              {
                text: item.price_total,
                style: "tableDetail",
                alignment: "right",
              },
              {
                text: item.final_compensation_price,
                style: "tableDetail",
                alignment: "right",
              },
            ]),
          ],
        },
      },
    ],
    footer: function (currentPage: number, pageCount: number) {
      const printDateMM = moment();
      return {
        stack: [
          {
            margin: [40, 0, 20, 0],
            columns: [
              {
                width: "50%",
                stack: [
                  {
                    text: `วันเวลาที่พิมพ์ : ${formatDate(
                      printDateMM
                    )} [${printDateMM.format("HH:mm")}]`,
                    style: "addressLeftStyle",
                  },
                  {
                    text: `ผู้ออกรายงาน : ${props?.print_user || ""}`,
                    style: "addressLeftStyle",
                  },
                ],
              },
              {
                width: "50%",
                stack: [
                  {
                    text: `หน้าที่ ${currentPage} / ${pageCount}`,
                    style: "addressRightStyle",
                  },
                ],
              },
            ],
          },
        ],
      };
    },
    images: {
      ...images,
    },
  };
};

export default FormAnesDoctorFeeList;
